import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';

import { TranslateService } from '../../../services/translate.service';
import { AuthStateService } from '../../../services/auth-state.service';

@Component({
  selector: 'app-user-popover',
  standalone: true,
  imports: [
    CommonModule,
    OverlayPanelModule,
    ButtonModule,
    DividerModule
  ],
  templateUrl: './user-popover.component.html',
  styleUrls: ['./user-popover.component.scss']
})
export class UserPopoverComponent implements OnInit {
  // We'll simulate a user object passed from the parent component
  // In a real app, this would be a user service or a user model
  // The @Input() property will be used to hold the user data.
  @Input() user: any = {};

  @Output() profileClicked = new EventEmitter<void>();
  @Output() settingsClicked = new EventEmitter<void>();
  @Output() signOutClicked = new EventEmitter<void>();

  constructor(public translateServ: TranslateService, private authStateService: AuthStateService){}

  // Use ngOnInit to initialize the user data when the component is created.
  ngOnInit(): void {
    this.updateName();
  }

  // This method will be responsible for getting the latest values
  // from AuthStateService's in-memory identity and updating the component's user object.
  public updateName(): void
  {
    const firstName = this.authStateService.getFirstName();
    const lastName = this.authStateService.getLastName();

    // Update the user object.
    this.user = {
      ...this.user, // Keep any other properties on the user object
      displayName: (firstName || '') + ' ' + (lastName || ''),
    };
  }

  // You can add methods here for specific actions
  onProfileClick(): void {
    this.profileClicked.emit();
  }

  onSettingsClick(): void {
    this.settingsClicked.emit();
  }

  public onSignOutClick(): void {
    this.signOutClicked.emit();
  }
}
